import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalCellular2Bar = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M.889 14.222 14.222.89v13.333z"
      />
    </g>
  </svg>
)
export default SvgSignalCellular2Bar
